import { render, staticRenderFns } from "./case-lawyer-action-tab.vue?vue&type=template&id=5a16d8ef&"
import script from "./case-lawyer-action-tab.vue?vue&type=script&lang=js&"
export * from "./case-lawyer-action-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports